import { useCallback, useRef } from 'react';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

export const useCondensedCircleContentTracking = ({
    vertical,
}: {
    vertical: string;
}): {
    handleSectionVisibilityChange: ({ isVisible }: { isVisible: boolean }) => void;
    handleCircleClick: (item: string) => void;
} => {
    const hasFiredVisibilityTracking = useRef(false);
    const handleSectionVisibilityChange = useCallback(
        ({ isVisible }: { isVisible: boolean }) => {
            if (isVisible && !hasFiredVisibilityTracking.current) {
                const action = 'condensed pdp circle content displayed';
                trackEvent({
                    category: 'promo interaction',
                    action,
                    label: vertical,
                    eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
                    interaction_type: action,
                    step_interaction_name: vertical,
                });
                hasFiredVisibilityTracking.current = true;
            }
        },
        [vertical]
    );
    const handleCircleClick = useCallback(
        (item: string) => {
            trackEvent({
                category: 'promo interaction',
                action: 'condensed pdp circle content clicked',
                label: vertical,
                eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
                interaction_type: interactionTypeConstants.INTERACTION_TYPE_ICONIC_DESIGNS,
                step_interaction_name:
                    stepInteractionConstants.STEP_INTERACTION_ICONIC_DESIGNS_CLICK,
                trigger: item,
            });
        },
        [vertical]
    );

    return {
        handleSectionVisibilityChange,
        handleCircleClick,
    };
};
